"use client"

import type React from "react"
import { useState, useEffect } from "react"

interface SliderProps {
    min?: number
    max?: number
    step?: number
    defaultValue?: number
    value?: number
    onChange?: (value: number) => void
    className?: string
}

// Add the 'export' keyword before the function declaration
export function Slider({
                           min = 0,
                           max = 100,
                           step = 1,
                           defaultValue = 0,
                           value,
                           onChange,
                           className = "",
                       }: SliderProps) {
    const [internalValue, setInternalValue] = useState(defaultValue)

    useEffect(() => {
        if (value !== undefined) {
            setInternalValue(value)
        }
    }, [value])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = Number(e.target.value)
        setInternalValue(newValue)
        if (onChange) {
            onChange(newValue)
        }
    }

    return (
        <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={value !== undefined ? value : internalValue}
            onChange={handleChange}
            className={`w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer ${className}`}
            style={{
                accentColor: "#C51321",
            }}
        />
    )
}

